import React from 'react';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import AquaApp from './pages/aqua/AquaApp';
import { ThemeProvider } from './context/ThemeContext';
import './App.css';

// En Electron la app se carga desde file://, donde BrowserRouter no funciona
// (la ruta real es /C:/.../index.html y pushState falla): se usa HashRouter.
const Router = window.aquaDesktop?.isDesktop ? HashRouter : BrowserRouter;

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <AquaApp />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
